<template>
	<div class="insert-plan">
		<div class="header">
			<div class="back" @click="fallback">
				<i class="iconfont">&#xe613;</i>
			</div>
			<div class="title">{{currentMonth}}份计划</div>
		</div>
		<div class="content-wrapper" ref="insertScroll">
			<div>
				<div class="content-title">
					<span class="left">{{currentMonth}}</span>
					<span class="right" @click="getLastMonth">加载上月计划</span>
				</div>
				<ul class="content-list">
					<li class="list-item">
						<p class="title">竞价</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="jj_in_count" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="jj_dialog_count" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="jj_sure_count" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="jj_order_price" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{jj_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{jj_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{jj_sure_base}}</b>元/人</span>
						</p>
					</li>
					<li class="list-item">
						<p class="title">优化</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="yh_in_count" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="yh_dialog_count" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="yh_sure_count" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="yh_order_price" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{yh_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{yh_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{yh_sure_base}}</b>元/人</span>
						</p>
					</li>
					<li class="list-item">
						<p class="title">门户</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="mh_in_count" name="visit" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="mh_dialog_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="mh_sure_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="mh_order_price" name="budget" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{mh_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{mh_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{mh_sure_base}}</b>元/人</span>
						</p>
					</li>
					<li class="list-item">
						<p class="title">新媒体</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="xmt_in_count" name="visit" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="xmt_dialog_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="xmt_sure_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="xmt_order_price" name="budget" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{xmt_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{xmt_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{xmt_sure_base}}</b>元/人</span>
						</p>
					</li>
					<li class="list-item">
						<p class="title">资源合作</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="zyhz_in_count" name="visit" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="zyhz_dialog_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="zyhz_sure_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="zyhz_order_price" name="budget" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{zyhz_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{zyhz_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{zyhz_sure_base}}</b>元/人</span>
						</p>
					</li>
					<li class="list-item">
						<p class="title">无轨迹</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="wgj_in_count" name="visit" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="wgj_dialog_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="wgj_sure_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="wgj_order_price" name="budget" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{wgj_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{wgj_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{wgj_sure_base}}</b>元/人</span>
						</p>
					</li>
					<li class="list-item">
						<p class="title">其他</p>
						<div class="input-item">
							<p class="input-block">
								<span class="text">到诊</span>
								<input type="number" v-model="qt_in_count" name="visit" class="input">
							</p>
							<p class="input-block">
								<span class="text">对话</span>
								<input type="number" v-model="qt_dialog_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">确诊对话</span>
								<input type="number" v-model="qt_sure_count" name="caht" class="input">
							</p>
							<p class="input-block">
								<span class="text">预算</span>
								<input type="number" v-model="qt_order_price" name="budget" class="input">
								<span class="price">万</span>
							</p>
						</div>
						<p class="cost">
							<span class="text">对话成本</span>
							<span class="price"><b>{{qt_dialog_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">到诊成本</span>
							<span class="price"><b>{{qt_in_base}}</b>元/人</span>
						</p>
						<p class="cost" v-show="hidden">
							<span class="text">确诊对话成本</span>
							<span class="price"><b>{{qt_sure_base}}</b>元/人</span>
						</p>
					</li>
				</ul>
				<div class="total-wrapper">
					<p class="total-title">汇总</p>
					<div class="total">
						<span class="item">到诊: <span class="total-number">{{total_in_count}}</span>人</span>
						<span class="item">对话: <span class="total-number">{{total_dialog_count}}</span>个</span>
						<span class="item">预算: <span class="total-number">{{total_order_price}}</span>万</span>
						<span class="item">到诊成本: <span class="total-number">{{total_in_base}}</span>元/人</span>
						<span class="item">对话成本: <span class="total-number">{{total_dialog_base}}</span>元/人</span>
						<span class="item">确诊对话: <span class="total-number">{{total_sure_count}}</span>个</span>
						<span class="item">确诊对话成本: <span class="total-number">{{total_sure_base}}</span>元/人</span>
					</div>
					<div class="target-number">
						<input type="number" v-model="come_on" name="targetNumber" class="input" placeholder='到诊冲刺目标人数:'>
					</div>
				</div>
			</div>
		</div>
		<div class="insert-confirm" @click="handleSubmit">
			确认
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import BScroll from 'better-scroll'
	import {fallback,computedCost,computedTotal,validate,getCurrentTime} from '@/assets/js/_mm.js'
	export default {
		name: 'createPlan',
		props: {
			type: String,
			monthId: String,
			selectMonth: {
				type: String,
				default: new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月'
			}
		},
		data () {
			return {
				hidden: false,
				createPageHidden: false,
				currentMonth: (() => {
				  return this.selectMonth
        		})(),
        		currentYear: (() => {
		          return new Date().getFullYear()
		        })(),
				//竞价
				jj_in_count: '',
				jj_dialog_count: '',
				jj_sure_count: '',
				jj_order_price: '',
				// 优化
				yh_in_count: '',
				yh_dialog_count: '',
				yh_sure_count: '',
				yh_order_price:　'',
				// 门户
				mh_in_count: '',
				mh_dialog_count: '',
				mh_sure_count: '',
				mh_order_price: '',
				// 新媒体
				xmt_in_count: '',
				xmt_dialog_count: '',
				xmt_sure_count: '',
				xmt_order_price: '',
				// 资源合作
				zyhz_in_count: '',
				zyhz_dialog_count: '',
				zyhz_sure_count: '',
				zyhz_order_price: '',
				// 无轨迹
				wgj_in_count: '',
				wgj_dialog_count: '',
				wgj_sure_count: '',
				wgj_order_price: '',
				// 其他
				qt_in_count: '',
				qt_dialog_count: '',
				qt_sure_count: '',
				qt_order_price: '',
				// 目标人数
				come_on: ''
			}
		},
		mounted () {
			this._initInsertScroll()
			this.getCurrentMonth()
		},
		computed: {
			//竞价到诊成本
			jj_in_base () {
				return computedCost(this.jj_order_price,this.jj_in_count)
			},
			// 竞价对话成本
			jj_dialog_base () {
				return computedCost(this.jj_order_price,this.jj_dialog_count)
			},
			// 竞价确诊对话成本
			jj_sure_base () {
				return computedCost(this.jj_order_price,this.jj_sure_count)
			},
			// 优化到诊成本
			yh_in_base () {
				return computedCost(this.yh_order_price,this.yh_in_count)
			},
			// 优化对话成本
			yh_dialog_base () {
				return computedCost(this.yh_order_price,this.yh_dialog_count)
			},
			// 优化对话成本
			yh_sure_base () {
				return computedCost(this.yh_order_price,this.yh_sure_count)
			},
			//门户到诊成本
			mh_in_base () {
				return computedCost(this.mh_order_price,this.mh_in_count)
			},
			//门户对话成本
			mh_dialog_base () {
				return computedCost(this.mh_order_price,this.mh_dialog_count)
			},
			//门户确诊对话成本
			mh_sure_base () {
				return computedCost(this.mh_order_price,this.mh_sure_count)
			},
			//新媒体到诊成本
			xmt_in_base () {
				return computedCost(this.xmt_order_price,this.xmt_in_count)
			},
			//新媒体对话成本
			xmt_dialog_base () {
				return computedCost(this.xmt_order_price,this.xmt_dialog_count)
			},
			//新媒体确诊对话成本
			xmt_sure_base () {
				return computedCost(this.xmt_order_price,this.xmt_sure_count)
			},
			//资源合作到诊成本
			zyhz_in_base () {
				return computedCost(this.zyhz_order_price,this.zyhz_in_count)
			},
			//资源合作对话成本
			zyhz_dialog_base () {
				return computedCost(this.zyhz_order_price,this.zyhz_dialog_count)
			},
			//资源合作确诊对话成本
			zyhz_sure_base () {
				return computedCost(this.zyhz_order_price,this.zyhz_sure_count)
			},
			//无轨迹到诊成本
			wgj_in_base () {
				return computedCost(this.wgj_order_price,this.wgj_in_count)
			},
			//无轨迹对话成本
			wgj_dialog_base () {
				return computedCost(this.wgj_order_price,this.wgj_dialog_count)
			},
			//无轨迹确诊对话成本
			wgj_sure_base () {
				return computedCost(this.wgj_order_price,this.wgj_sure_count)
			},
			// 其他到诊成本
			qt_in_base () {
				return computedCost(this.qt_order_price,this.qt_in_count)
			},
			// 其他对话成本
			qt_dialog_base () {
				return computedCost(this.qt_order_price,this.qt_dialog_count)
			},
			// 其他确诊对话成本
			qt_sure_base () {
				return computedCost(this.qt_order_price,this.qt_sure_count)
			},
			// 到诊汇总
			total_in_count () {
				let result = computedTotal(this.jj_in_count,this.yh_in_count,this.mh_in_count,this.xmt_in_count,this.zyhz_in_count,this.wgj_in_count,this.qt_in_count)
				if(!!result) {
					return parseInt(result)
				}else {
					return result
				}
			},
			//对话汇总
			total_dialog_count () {
				let result = computedTotal(this.jj_dialog_count,this.yh_dialog_count,this.mh_dialog_count,this.xmt_dialog_count,this.zyhz_dialog_count,this.wgj_dialog_count,this.qt_dialog_count)
				if(!!result) {
					return parseInt(result)
				}else {
					return result
				}
			},
			//确诊对话汇总
			total_sure_count () {
				let result = computedTotal(this.jj_sure_count,this.yh_sure_count,this.mh_sure_count,this.xmt_sure_count,this.zyhz_sure_count,this.wgj_sure_count,this.qt_sure_count)
				if(!!result) {
					return parseInt(result)
				}else {
					return result
				}
			},
			// 预算汇总
			total_order_price () {
				return computedTotal(this.jj_order_price,this.yh_order_price,this.mh_order_price,this.xmt_order_price,this.zyhz_order_price,this.wgj_order_price,this.qt_order_price)
			},
			// 到诊成本汇总
			total_in_base () {
				return computedCost(this.total_order_price, this.total_in_count)
			},
			// 确诊对话成本汇总 
			total_sure_base () {
				return computedCost(this.total_order_price, this.total_sure_count)
			},
			// 对话成本汇总
			total_dialog_base () {
				return computedCost(this.total_order_price,this.total_dialog_count)
			}
		},
		methods: {
			fallback,
			computedCost,
			show () {
				this.createPageHidden = true
			},
			hide () {
				this.createPageHidden = false
			},
			_initInsertScroll () {
				this.$nextTick(() => {
					this.insertScroll = new BScroll(this.$refs.insertScroll,{
						click: true,
						swipeBounceTime: 100
					})
				})
			},
			getCurrentMonth () {
				if(this.type === 'update'){
					axios.get('/phal/public/',{
						params: {
							s: 'App.Report.Sel_month_plan',
							time: this.currentMonth.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2'),
							hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0]
						}
					}).then((res) => {
						let result = res.data
						if (result.ret && result.ret === 200) {
							let data = result.data
							// 竞价
							this.jj_in_count = data.jj_in_count,
							this.jj_dialog_count = data.jj_dialog_count,
							this.jj_sure_count = data.jj_sure_count,
							this.jj_order_price = data.jj_order_price / 10000,
							// 优化
							this.yh_in_count = data.yh_in_count,
							this.yh_dialog_count = data.yh_dialog_count,
							this.yh_sure_count = data.yh_sure_count,
							this.yh_order_price = data.yh_order_price / 10000,
							// 门户
							this.mh_in_count = data.mh_in_count,
							this.mh_dialog_count = data.mh_dialog_count,
							this.mh_sure_count = data.mh_sure_count,
							this.mh_order_price = data.mh_order_price / 10000,
							// 新媒体渲染
							this.xmt_in_count = data.xmt_in_count,
							this.xmt_dialog_count = data.xmt_dialog_count,
							this.xmt_sure_count = data.xmt_sure_count,
							this.xmt_order_price = data.xmt_order_price / 10000,
							// 资源合作
							this.zyhz_in_count = data.zyhz_in_count,
							this.zyhz_dialog_count = data.zyhz_dialog_count,
							this.zyhz_sure_count = data.zyhz_sure_count,
							this.zyhz_order_price = data.zyhz_order_price / 10000,
							// 无轨迹
							this.wgj_in_count = data.wgj_in_count,
							this.wgj_dialog_count = data.wgj_dialog_count,
							this.wgj_sure_count = data.wgj_sure_count,
							this.wgj_order_price = data.wgj_order_price / 10000,
							// 其他
							this.qt_in_count = data.qt_in_count,
							this.qt_dialog_count = data.qt_dialog_count,
							this.qt_sure_count = data.qt_sure_count,
							this.qt_order_price = data.qt_order_price / 10000,

							this.come_on = data.come_on
						}
					})
				}
			},
			getLastMonth () {
				let keep = this.currentMonth.split(/\D+/g)
				if(keep[1] <= 1) {
					this.currentMonth = keep[0] + '年12月'
				}else{
					this.currentMonth = keep[0] + '年' + (keep[1] - 1) + '月'
				}
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_month_plan',
						time: this.currentMonth.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2'),
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0]
					}
				}).then((res) => {
					let result = res.data
					if (result.ret && result.ret === 200) {
						let data = result.data
						if(data.length != 0) {
								// 竞价
							this.jj_in_count = data.jj_in_count,
							this.jj_dialog_count = data.jj_dialog_count,
							this.jj_sure_count = data.jj_sure_count,
							this.jj_order_price = data.jj_order_price / 10000,
							// 优化
							this.yh_in_count = data.yh_in_count,
							this.yh_dialog_count = data.yh_dialog_count,
							this.yh_sure_count = data.yh_sure_count,
							this.yh_order_price = data.yh_order_price / 10000,
							// 门户
							this.mh_in_count = data.mh_in_count,
							this.mh_dialog_count = data.mh_dialog_count,
							this.mh_sure_count = data.mh_sure_count,
							this.mh_order_price = data.mh_order_price / 10000,
							// 新媒体渲染
							this.xmt_in_count = data.xmt_in_count,
							this.xmt_dialog_count = data.xmt_dialog_count,
							this.xmt_sure_count = data.xmt_sure_count,
							this.xmt_order_price = data.xmt_order_price / 10000,
							// 资源合作
							this.zyhz_in_count = data.zyhz_in_count,
							this.zyhz_dialog_count = data.zyhz_dialog_count,
							this.zyhz_sure_count = data.zyhz_sure_count,
							this.zyhz_order_price = data.zyhz_order_price / 10000,
							// 无轨迹
							this.wgj_in_count = data.wgj_in_count,
							this.wgj_dialog_count = data.wgj_dialog_count,
							this.wgj_sure_count = data.wgj_sure_count,
							this.wgj_order_price = data.wgj_order_price / 1000,
							// 其他
							this.qt_in_count = data.qt_in_count,
							this.qt_dialog_count = data.qt_dialog_count,
							this.qt_sure_count = data.qt_sure_count,
							this.qt_order_price = data.qt_order_price / 10000,


							this.come_on = data.come_on
						}else{
							// 竞价
							this.jj_in_count = ''
							this.jj_dialog_count = ''
							this.jj_sure_count = ''
							this.jj_order_price = ''
							// 优化
							this.yh_in_count = ''
							this.yh_dialog_count = ''
							this.yh_sure_count = ''
							this.yh_order_price = ''
							// 门户
							this.mh_in_count = ''
							this.mh_dialog_count = ''
							this.mh_sure_count = ''
							this.mh_order_price = ''
							// 新媒体
							this.xmt_in_count = '',
							this.xmt_dialog_count = '',
							this.xmt_sure_count = '',
							this.xmt_order_price = '',
							// 资源合作
							this.zyhz_in_count = '',
							this.zyhz_dialog_count = '',
							this.zyhz_sure_count = '',
							this.zyhz_order_price = '',
							// 无轨迹
							this.wgj_in_count = '',
							this.wgj_dialog_count = '',
							this.wgj_sure_count = '',
							this.wgj_order_price = '',
							// 其他
							this.qt_in_count = ''
							this.qt_dialog_count = ''
							this.qt_sure_count = ''
							this.qt_order_price = ''

							this.come_on = ''
						}
					}
				})
			},
			handleSubmit () {
				switch (this.type) {
					case 'insert':
						this.planInsert()
						break
					case 'update':
						this.planUpdate()
						break
				}
			},
			planUpdate () {
				if(!validate(this.total_in_count,'require')) {
					this.$alert('到诊汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_dialog_count,'require')) {
					this.$alert({
						title: '提示',
						content: '到诊汇总不能为空请完善信息'
					})
					this.$alert('对话汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_order_price,'require')) {
					this.$alert('预算汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_in_base,'require')) {
					this.$alert('到诊成本汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_dialog_base,'require')) {
					this.$alert('对话成本汇总不能为空请完善信息')
					return
				}
				if(!validate(this.come_on,'require')) {
					this.$alert('冲刺目标不能为空请完善信息')
					return
				}
				if(parseInt(this.come_on) < parseInt(this.total_in_count)) {
					this.$alert('冲刺人数不能小于到诊汇总,请重新填写')
					return
				}
				axios.get('/phal/public/',{
					params:{
						s: 'App.Report.Upt_month_plan',
						id: Number(this.monthId),
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: this.currentMonth.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2'),
						jj_in_count: this.jj_in_count,
						jj_dialog_count: this.jj_dialog_count,
						jj_sure_count: this.jj_sure_count,
						jj_order_price: Math.floor(this.jj_order_price * 10000),
						jj_in_base: this.jj_in_base,
						jj_dialog_base: this.jj_dialog_base,
						jj_sure_base: this.jj_sure_base,
						yh_in_count: this.yh_in_count,
						yh_dialog_count: this.yh_dialog_count,
						yh_sure_count: this.yh_sure_count,
						yh_order_price: Math.floor(this.yh_order_price * 10000),
						yh_in_base: this.yh_in_base,
						yh_dialog_base: this.yh_dialog_base,
						yh_sure_base: this.yh_sure_base,
						mh_in_count: this.mh_in_count,
						mh_dialog_count: this.mh_dialog_count,
						mh_sure_count: this.mh_sure_count,
						mh_order_price: Math.floor(this.mh_order_price * 10000),
						mh_in_base: this.mh_in_base,
						mh_dialog_base: this.mh_dialog_base,
						mh_sure_base: this.mh_sure_base,
						xmt_in_count: this.xmt_in_count,
						xmt_dialog_count: this.xmt_dialog_count,
						xmt_sure_count: this.xmt_sure_count,
						xmt_order_price: Math.floor(this.xmt_order_price * 10000),
						xmt_in_base: this.xmt_in_base,
						xmt_dialog_base: this.xmt_dialog_base,
						xmt_sure_base: this.xmt_sure_base,
						zyhz_in_count: this.zyhz_in_count,
						zyhz_dialog_count: this.zyhz_dialog_count,
						zyhz_sure_count: this.zyhz_sure_count,
						zyhz_order_price: Math.floor(this.zyhz_order_price * 10000),
						zyhz_in_base: this.zyhz_in_base,
						zyhz_dialog_base: this.zyhz_dialog_base,
						zyhz_sure_base: this.zyhz_sure_base,
						wgj_in_count: this.wgj_in_count,
						wgj_dialog_count: this.wgj_dialog_count,
						wgj_sure_count: this.wgj_sure_count,
						wgj_order_price: Math.floor(this.wgj_order_price * 10000),
						wgj_in_base: this.wgj_in_base,
						wgj_dialog_base: this.wgj_dialog_base,
						wgj_sure_base: this.wgj_sure_base,
						qt_in_count: this.qt_in_count,
						qt_dialog_count: this.qt_dialog_count,
						qt_sure_count: this.qt_sure_count,
						qt_order_price: Math.floor(this.qt_order_price * 10000),
						qt_in_base: this.qt_in_base,
						qt_dialog_base: this.qt_dialog_base,
						qt_sure_base: this.qt_sure_base,
						total_in_count: this.total_in_count,
						total_dialog_count: this.total_dialog_count,
						total_sure_count: this.total_sure_count,
						total_order_price: Math.floor(this.total_order_price * 10000),
						total_in_base: this.total_in_base,
						total_dialog_base: this.total_dialog_base,
						total_sure_base: this.total_sure_base,
						come_on: this.come_on
					}
				}).then((res) => {
					let data = res.data
					if(data && data.ret === 200){
						this.$alert({
							title: '提示',
							content: '编辑成功'
						}).then(() => {
							this.$router.push('/plan')
						})
					}else {
						this.$alert({
							title: '提示',
							content: data.data
						}).then(() => {
							this.$router.push('/plan')
						})
					}
				})
			},
			planInsert () {
				if(!validate(this.total_in_count,'require')) {
					this.$alert('到诊汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_dialog_count,'require')) {
					this.$alert({
						title: '提示',
						content: '到诊汇总不能为空请完善信息'
					})
					this.$alert('对话汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_order_price,'require')) {
					this.$alert('预算汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_in_base,'require')) {
					this.$alert('到诊成本汇总不能为空请完善信息')
					return
				}
				if(!validate(this.total_dialog_base,'require')) {
					this.$alert('对话成本汇总不能为空请完善信息')
					return
				}
				if(!validate(this.come_on,'require')) {
					this.$alert('冲刺目标不能为空请完善信息')
					return
				}
				if(Number(this.come_on) < this.total_in_count) {
					this.$alert('冲刺人数不能小于到诊汇总,请重新填写')
					return
				}
				axios.get('/phal/public/',{
					params:{
						s: 'App.Report.Add_month_plan',
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: this.currentMonth.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2'),
						jj_in_count: this.jj_in_count,
						jj_dialog_count: this.jj_dialog_count,
						jj_sure_count: this.jj_sure_count,
						jj_order_price: Math.floor(this.jj_order_price * 10000),
						jj_in_base: this.jj_in_base,
						jj_dialog_base: this.jj_dialog_base,
						jj_sure_base: this.jj_sure_base,
						yh_in_count: this.yh_in_count,
						yh_dialog_count: this.yh_dialog_count,
						yh_sure_count: this.yh_sure_count,
						yh_order_price: Math.floor(this.yh_order_price * 10000),
						yh_in_base: this.yh_in_base,
						yh_dialog_base: this.yh_dialog_base,
						yh_sure_base: this.yh_sure_base,
						mh_in_count: this.mh_in_count,
						mh_dialog_count: this.mh_dialog_count,
						mh_sure_count: this.mh_sure_count,
						mh_order_price: Math.floor(this.mh_order_price * 10000),
						mh_in_base: this.mh_in_base,
						mh_dialog_base: this.mh_dialog_base,
						mh_sure_base: this.mh_sure_base,
						xmt_in_count: this.xmt_in_count,
						xmt_dialog_count: this.xmt_dialog_count,
						xmt_sure_count: this.xmt_sure_count,
						xmt_order_price: Math.floor(this.xmt_order_price * 10000),
						xmt_in_base: this.xmt_in_base,
						xmt_dialog_base: this.xmt_dialog_base,
						xmt_sure_base: this.xmt_sure_base,
						zyhz_in_count: this.zyhz_in_count,
						zyhz_dialog_count: this.zyhz_dialog_count,
						zyhz_sure_count: this.zyhz_sure_count,
						zyhz_order_price: Math.floor(this.zyhz_order_price * 10000),
						zyhz_in_base: this.zyhz_in_base,
						zyhz_dialog_base: this.zyhz_dialog_base,
						zyhz_sure_base: this.zyhz_sure_base,
						wgj_in_count: this.wgj_in_count,
						wgj_dialog_count: this.wgj_dialog_count,
						wgj_sure_count: this.wgj_sure_count,
						wgj_order_price: Math.floor(this.wgj_order_price * 10000),
						wgj_in_base: this.wgj_in_base,
						wgj_dialog_base: this.wgj_dialog_base,
						wgj_sure_base: this.wgj_sure_base,
						qt_in_count: this.qt_in_count,
						qt_dialog_count: this.qt_dialog_count,
						qt_sure_count: this.qt_sure_count,
						qt_order_price: Math.floor(this.qt_order_price * 10000),
						qt_in_base: this.qt_in_base,
						qt_dialog_base: this.qt_dialog_base,
						qt_sure_base: this.qt_sure_base,
						total_in_count: this.total_in_count,
						total_dialog_count: this.total_dialog_count,
						total_sure_count: this.total_sure_count,
						total_order_price: Math.floor(this.total_order_price * 10000),
						total_in_base: this.total_in_base,
						total_dialog_base: this.total_dialog_base,
						total_sure_base: this.total_sure_base,
						come_on: this.come_on
					}
				}).then((res) => {
					let data = res.data
					if(data && data.ret === 200){
						this.$alert({
							title: '提示',
							content: '添加成功'
						}).then(() => {
							this.$router.push('/plan')
						})
					}else {
						this.$alert({
							title: '提示',
							content: data.data
						}).then(() => {
							this.$router.push('/plan')
						})
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.insert-plan
		position: fixed
		top: 0
		right: 0
		bottom: 0
		left: 0
		background-color: #f2f2f2
		.header
			display: flex
			height: 1.1rem
			line-height: 1.1rem
			padding: 0 .2rem 0 .4rem
			background-color: #fff
			.back
				flex: 0 0 .64rem
				font-size: .42rem
				.iconfont
					font-size: .42rem
			.title
				flex: 1
				text-align: center
		.content-wrapper
			position: fixed
			top: 1.1rem
			right: 0
			bottom: 1rem
			left: 0
			z-index: 1000
			overflow: hidden
			.content-title
				display: flex
				justify-content: space-between
				padding: .3rem .32rem
				line-height: .5rem
				color: #888
				background:#fff;
				margin:0.1rem auto
			.content-list
				display: flex
				flex-wrap: wrap
				justify-content: space-between
				.list-item
					box-sizing: border-box
					width: 49.5%;
					margin-bottom: .1rem
					padding: 0.15rem .15rem .48rem .3rem
					color: #93989c
					background-color: #ffffff
					.title
						padding: .28rem 0 .4rem 0
						color: #666
						font-size: .25rem
						font-weight:bold
					.input-item
						.input-block
							position: relative
							height: .48rem
							line-height: .6rem
							margin-bottom: .4rem
							font-size: 0
							text-align: center
							.text
								display: inline-block
								vertical-align: top
								font-size: .25rem
								width: 1rem
							.input
								box-sizing: border-box
								display: inline-block
								vertical-align: top
								width: 2rem
								height: .6rem
								margin-left: .2rem
								padding: .08rem .1rem
								font-size: .26rem
								border-bottom: 1px solid #999
								color:#666
								font-weight:bold
							.price
								position: absolute
								right: .3rem
								font-size: .25rem
								color:#999
					.cost
						height: 1rem
						line-height: 1rem
						font-size: .25rem
						text-align: center
						&:last-child
							height: 0
							opacity: 0
						.text
							margin-right: .24rem
						.price b
							color:#09f
							margin-right:0.11rem
							font-weight:bold
			.total-wrapper
				padding:0.3rem 0.3rem .3rem 0.3rem
				color: #93989c
				font-size: 0.3rem
				background:#fff
				.total-title
					line-height: .6rem
					color: #666
					font-weight:bold
				.total
					display: flex
					flex-wrap: wrap
					justify-content: space-between
					.item
						height: .64rem
						line-height: .64rem
						.total-number
							display: inline-block
							min-width: .5rem
							text-align: right
							font-weight:bold
							color:#09f
							margin:0 3px
				.target-number
					.input
						box-sizing: border-box
						display: block
						width: 100%
						height: .78rem
						margin-top: .24rem
						padding: .12rem
						border-bottom: 1px solid #cbcbcb
						background-color: #ffffff
		.insert-confirm
			position: fixed
			bottom: 0
			left: 0
			right: 0
			z-index: 110
			width: 100%
			height: 1rem
			line-height: 1rem
			text-align: center
			color: #d09eb7
			font-size: .36rem
			background-color: #09f
			color:#fff
</style>



// WEBPACK FOOTER //
// src/pages/insert-plan/insert-plan.vue